'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import LoginModal from '@/components/auth/loginModal';
import { useAuth } from '@/providers/userContext';
import { setPostLoginRedirect } from '@/lib/client/postLoginRedirect';
import { useExplore } from './ExploreProvider';
const OPTIONS = [{
  id: 'all',
  label: 'All Hearts'
}, {
  id: 'saved',
  label: 'Saved'
}, {
  id: 'visited',
  label: 'Visited'
}];
export function HeartsScopeToggle(t0) {
  const $ = _c(14);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    user
  } = useAuth();
  const {
    heartsScope,
    setHeartsScope,
    filters
  } = useExplore();
  const [showLoginModal, setShowLoginModal] = useState(false);
  if (!filters?.hearts) {
    return null;
  }
  let t2;
  if ($[0] !== setHeartsScope || $[1] !== user) {
    t2 = nextScope => {
      if (!user) {
        if (nextScope === "visited") {
          setPostLoginRedirect("/account/visited");
          setShowLoginModal(true);
          return;
        }
        setHeartsScope(nextScope);
        return;
      }
      setHeartsScope(nextScope);
    };
    $[0] = setHeartsScope;
    $[1] = user;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleSelect = t2;
  const t3 = `inline-flex w-full items-center rounded-full bg-white/95 p-1 border border-[#E0E0E0] ${className}`;
  let t4;
  if ($[3] !== handleSelect || $[4] !== heartsScope) {
    t4 = OPTIONS.map(option => {
      const isActive = heartsScope === option.id;
      return <button key={option.id} type="button" onClick={() => handleSelect(option.id)} className={`flex-1 rounded-full px-3 py-2 text-sm font-semibold transition-colors cursor-pointer ${isActive ? "bg-[#00EAFD] text-[#323232]" : "text-[#626262] hover:bg-[#F2F2F2] hover:text-[#323232]"}`}>{option.label}</button>;
    });
    $[3] = handleSelect;
    $[4] = heartsScope;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== showLoginModal) {
    t6 = showLoginModal && <LoginModal onClose={() => setShowLoginModal(false)} />;
    $[9] = showLoginModal;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}